import * as React from 'react'
import { CreateInvoiceDetail } from '../InvoiceDetailStore'
import { observer } from 'mobx-react-lite'
import { Descriptions, Row, Tooltip, Icon } from 'antd'
import { Currency } from '../../../../../components/Currency'

interface Props {
  createInvoice: CreateInvoiceDetail
}

export const InvoiceSummaryTable = observer((props: Props) => {
  const { createInvoice } = props
  const groupedTaxes = createInvoice.invoiceDetail?.groupedTaxes || []
  const subTotal = createInvoice.isEditMode
    ? createInvoice.total - createInvoice.taxTotal
    : createInvoice.invoiceDetail?.subTotal || 0

  const total = createInvoice.isEditMode
    ? createInvoice.total
    : createInvoice.invoiceDetail?.total || 0

  const amountOwing = createInvoice.isEditMode
    ? createInvoice.total - createInvoice.paid
    : (createInvoice.invoiceDetail?.total || 0) - (createInvoice.invoiceDetail?.paid || 0)

  return (
    <Descriptions
      bordered
      size='small'
      column={1}
      className='white-rounded-container'
      style={{ marginBottom: '80px' }}
    >
      {!createInvoice.isEditMode &&
        createInvoice.fees.map((fee, index) => {
          const feeName = fee.name ? `#${index + 1} Fee - ${fee.name}` : `#${index + 1} Fee`

          return (
            <Descriptions.Item
              key={index}
              className='text-right'
              label={
                <Row className='d-flex align-items-center'>
                  <span>{feeName}</span>

                  {!!fee.notes && (
                    <Tooltip title={fee.notes}>
                      <Icon className='ml-2' type='exclamation-circle' />
                    </Tooltip>
                  )}
                </Row>
              }
            >
              <Currency centValue={fee.total} />
            </Descriptions.Item>
          )
        })}

      <Descriptions.Item className='text-right' label='Subtotal'>
        <Currency centValue={subTotal} />
      </Descriptions.Item>

      {createInvoice.isEditMode ? (
        <Descriptions.Item className='text-right' label='Tax'>
          <Currency centValue={createInvoice.taxTotal} />
        </Descriptions.Item>
      ) : (
        groupedTaxes.map((tax) => (
          <Descriptions.Item key={tax.taxId} className='text-right' label={tax.taxName}>
            <Currency centValue={tax.totalAmount} />
          </Descriptions.Item>
        ))
      )}

      <Descriptions.Item className='text-right' label='Total'>
        <Currency centValue={total} />
      </Descriptions.Item>

      {!createInvoice.isReturn && (
        <Descriptions.Item className='text-right' label='Amount owing'>
          <Currency centValue={amountOwing} />
        </Descriptions.Item>
      )}
    </Descriptions>
  )
})
